export enum UploadTypeEnum {
  UNKNOWN = "unknown",
  OFFERS = "offers",
  PRICE_LIST = "pricelist",
}
